import { trpc } from '@/shared/api';

interface GuestQuoteRequestFormQueryInput {
  readonly productId: string;
  readonly colorOptionId: string;
}

interface GuestQuoteRequestFormQueryOptions {
  readonly enabled?: boolean;
}

/**
 * 비회원 견적 요청 정보(quotes.getGuestRequestForm, 비회원 견적 설계 G12) — 상품·색상 이름·최소 수량·구간 단가·인쇄 방식.
 * 비회원은 저장한 디자인이 없어 상품·색상으로 묻는다(디자인 썸네일·기본 담당자명은 없다). 요청 불가(상품 숨김·색상 공급 불가)는
 * 다시 물어도 같아 재시도하지 않는다.
 */
export const useGuestQuoteRequestFormQuery = (
  { productId, colorOptionId }: GuestQuoteRequestFormQueryInput,
  options: GuestQuoteRequestFormQueryOptions = {},
) =>
  trpc.quotes.getGuestRequestForm.useQuery(
    { productId, colorOptionId },
    { enabled: options.enabled ?? true, retry: false },
  );
